import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';
import { UserTData } from '../styles/Users.styles';

export const UserData = styled(UserTData).attrs(() => ({}))`
  font-weight: 400;
  font-size: 14px;
`;

export const UserContainer = styled.div`
  display: contents;
  &:hover ${UserData} {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const EditRole = styled(Box).attrs(({ theme }) => ({
  color: 'primaryText',
  border: `solid 1px ${theme.colors.heavyLineOutline}`,
  borderRadius: '5px',
  py: 2,
  px: 3,
}))`
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.13314);
  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;
